import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import useBookingPage from 'services/store/BookingPage';
import { useSearchParams } from "react-router-dom";
import useLoadedStore from 'services/store/LoadedPage';
import liff from "@line/liff";
import axios from "axios";

const EventPolicy = () => {
    useLoadedStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { profile } = useBookingPage();
    const [lineId, setLineId] = useState(null);
    const [isOpenNoLink, setIsOpenNoLink] = useState(false);
    const userToken = window.localStorage.getItem('userToken');
    const qToken = searchParams.get('token') ?? userToken;
    window.localStorage.setItem('userToken', qToken);
    useEffect(() => {
        getLineLiff();
    }, []);

    const getLineLiff = async () => {
        await liff.init({ liffId: "2000814971-bMYJ9XVd" })
        if (liff.isInClient()) {
            const _lineId = liff.getDecodedIDToken()?.sub
            console.log(_lineId)
            setLineId(_lineId);
        } else {
            if (liff.isLoggedIn()) {
                const _lineId = liff.getDecodedIDToken()?.sub
                console.log(_lineId)
                setLineId(_lineId);
            } else {
                liff.login({ redirectUri: window.location.href })
            }
        }
    }

    const handleOk = () => {
        try {
            const data = { user_id: lineId, }
            axios.post('https://open-api.chatcone.com/nestle/talk_to_human', data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55X2lkIjoiNjUwYzBjYjg2MjZhZGI5ZTY1NDhmN2JjIiwiaWF0IjoxNzUxMDA5MjI5fQ.8zXEwBN1oWhfbXHP2wrbonkBixPqCivzNleqOo0Sd9M'
                    },
                }
            )
                .then(async (res) => {
                    console.log('GET api main success >>', res)
                    liff.closeWindow();
                })
                .catch((e) => {
                    // const resData = e?.response?.data ?? {};
                    console.log("GET api main err >>", e.response.data);
                    // return e;
                });
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="EventPolicy">
                <main>
                    <div className="header">
                        รายละเอียดกติกาและ
                        <br></br>
                        เงื่อนไขการเข้าร่วมกิจกรรม

                    </div>
                    <div className='pContent'>
                        <h>1. กติกาในการร่วมสนุก</h>
                        <p>แอดมินขอชวนคุณแม่มาร่วมกิจกรรมง่ายๆ เพียง</p>
                        <ul>
                            <li>นำใบเสร็จการซื้อนม S-26 Gold UHT หรือ S-26 Gold Pro UHT จาก 7-Eleven สาขาใดก็ได้ มูลค่า 150 บาทขึ้นไป เพื่อแลกรับแก้วกันบีบนมกล่อง จำนวน 1 ชิ้น มูลค่า 100 บาทฟรี จำนวนทั้งหมด 1,000 ชิ้น โดยสงวนสิทธิ์ผู้ร่วมกิจกรรม 1 ท่านต่อ 1 ใบเสร็จ ต่อ 1 ของสมนาคุณ ตลอดระยะเวลากิจกรรม</li>
                            <li>โดยผู้ร่วมกิจกรรมส่งภาพถ่ายใบเสร็จที่ตรงตามเงื่อนไขมาที่ LINE Official Account ชื่อบัญชี @s-momclubgold ภายในระยะเวลาตั้งแต่วันที่ 1 กรกฎาคม 2568 – 31 สิงหาคม 2568  โดยแบ่งออกเป็น 4 รอบ ดังนี้
                                <ul style={{ listStyleType: "circle" }}>
                                    <li>รอบที่ 1 วันที่ 1 กรกฏาคม 2568 – 15 กรกฏาคม 2568 จำนวน 250 สิทธิ์</li>
                                    <li>รอบที่ 2 วันที่ 16 กรกฏาคม 2568 – 31 กรกฏาคม 2568 จำนวน 250 สิทธิ์</li>
                                    <li>รอบที่ 3 วันที่ 1   สิงหาคม 2568 – 15 สิงหาคม 2568 จำนวน 250 สิทธิ์</li>
                                    <li>รอบที่ 4 วันที่ 16 สิงหาคม 2568 – 31 สิงหาคม 2568 จำนวน 250 สิทธิ์</li>
                                </ul>
                            </li>
                            <li>ในกรณีที่สิทธิ์การแลกของสมนาคุณในแต่ละรอบเต็มแล้ว จะมีข้อความแจ้งผู้ร่วมกิจกรรมที่ Line OA และผู้ร่วมกิจกรรมสามารถนำใบเสร็จที่ซื้อในระยะเวลารอบใดรอบ หนึ่งไปแลกของสมณาคุณในรอบถัดไปได้</li>
                            <li>ขอสงวนสิทธิ์ผู้เข้าร่วมกิจกรรมที่ส่งใบเสร็จมาถูกต้องครบถ้วน ก่อน และจะปิดรับทันทีหลังจากมีการแลกของสมณาคุณ ครบจำนวนในแต่ละรอบ</li>
                        </ul>
                        <h>2. ข้อตกลงและเงื่อนไข</h>
                        <ol>
                            <li>2.1 กิจกรรมนี้สงวนสิทธิ์ให้กับผู้ร่วมกิจกรรมที่มีอายุ 13 ปีขึ้นไป</li>
                            <li>2.2 กรุณายืนยันสิทธิ์โดยแจ้งชื่อและนามสกุลจริง ที่อยู่ เพื่อการรับของสมนาคุณ หากบริษัท เนสท์เล่ (ไทย) จำกัด (“บริษัทฯ”) ไม่สามารถติดต่อท่านได้ภายใน 15 วัน จะถือว่าท่านสละสิทธิ์ในการรับของสมณาคุณได้ บริษัทฯ ขอสงวนสิทธิ์ในการยกเลิกการมอบของสมนาคุณให้แก่ ผู้เข้าร่วมกิจกรรมท่านนั้นๆ</li>
                            <li>2.3 บริษัทฯ จะจัดส่งของสมนาคุณให้แก่ผู้ร่วมกิจกรรมทางไปรษณีย์ ลงทะเบียนตอบรับภายใน 30 วัน นับจากวันที่ยืนยันสิทธิสมบูรณ์ โดยเริ่มจัดส่งของสมนาคุณตั้งแต่วันที่ 01 สิงหาคม 2568 เป็นต้นไป</li>
                            <li>2.4 บริษัทฯ ไม่มีส่วนรับผิดชอบในความเสียหาย การสูญหาย จากการร่วมกิจกรรมหรือการรับของสมนาคุณ และบริษัทฯ ไม่มีส่วนรับผิดชอบในความเสียหายที่เกิดจากความล่าช้าหรือเนื่องมา จากการขนส่งของสมนาคุณ การสูญหายของข้อมูลการลงทะเบียน รวมถึงปัญหาหรือความผิดพลาดทางเทคนิคของเครือข่ายโทรศัพท์ ระบบคอมพิวเตอร์ออนไลน์ เซิร์ฟเวอร์ ผู้ให้บริการ อุปกรณ์คอมพิวเตอร์ และซอฟต์แวร์</li>
                            <li>2.5 บริษัทฯ ของดการจัดส่งของสมนาคุณซ้ำ ในกรณีที่บริษัทฯ มีหลักฐานการรับของสมนาคุณที่ถูกต้องจากบริษัทที่ทำหน้าที่จัดส่ง สินค้า</li>
                            <li>2.6 ผู้เข้าร่วมกิจกรรมทุกท่านถือว่ารับทราบและยินยอมปฎิบัติตาม กติกาการเข้าร่วมกิจกรรมฉบับนี้ โดยไม่มีข้อโต้แย้งใดๆ</li>
                            <li>2.7 หากมีข้อพิพาทหรือโต้แย้งใดๆ คำตัดสิน และดุลยพินิจใดๆ ของคณะกรรมการ และ/หรือ ของบริษัทฯ ถือเป็นเด็ดขาด และสิ้นสุดในทุกกรณี</li>
                        </ol>
                        <div className="bBtn">
                            <button className="btn" onClick={handleOk}>ยินยอม</button>
                        </div>


                    </div>

                </main>
            </div>

        </div>
    )
}

export default EventPolicy